// import * as types from '../../mutation-types'

const mutations = {}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/raceResume/mutations.js